import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, icon, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    accent: 'bg-accent/10 text-accent',
  };

  const trendColors = {
    up: 'text-success',
    down: 'text-destructive',
    neutral: 'text-muted-foreground',
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 shadow-warm-sm hover:shadow-warm transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-xs md:text-sm text-muted-foreground font-caption mb-2">
            {title}
          </p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            {value}
          </p>
        </div>
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${colorClasses?.[color]} flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={20} />
        </div>
      </div>
      {trend && trendValue && (
        <div className="flex items-center gap-2">
          <Icon
            name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'}
            size={16}
            color={`var(--color-${trend === 'up' ? 'success' : trend === 'down' ? 'destructive' : 'muted-foreground'})`}
          />
          <span className={`text-xs md:text-sm font-medium font-caption ${trendColors?.[trend]}`}>
            {trendValue}
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;